window.Visualizations.Highcharts.NewMultipleColumn = Object.assign({}, window.Visualizations.Highcharts.Base, {
  render: function (opts) {
    var jsOpts = {
      chart: {
        type: 'column',
        spacing: [12, 16, 16, 68], // Top, right, bottom, left spacing
        height: 296
      },
      title: {
        text: '' // No title in chart - it's in the accordion header
      },
      xAxis: {
        categories: opts.categories,
        labels: {
          style: {
            fontSize: '16px',
            color: 'rgba(0, 0, 0, 0.7)',
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 'normal'
          },
          padding: 10
        },
        lineColor: 'rgba(0, 0, 26, 0.3)',
        tickColor: 'transparent',
        lineWidth: 1
      },
      yAxis: {
        min: 0,
        title: {
          text: opts.y_title
        },
        labels: {
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0, '-', ',');
          },
          style: {
            fontSize: '16px',
            color: 'rgba(0, 0, 0, 0.7)',
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 'normal'
          },
          x: -4
        },
        gridLineColor: 'rgba(0, 0, 0, 0.1)',
        lineColor: 'rgba(0, 0, 26, 0.3)',
        lineWidth: 1
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        itemStyle: {
          fontSize: '16px',
          color: 'rgba(0, 0, 0, 0.7)',
          fontFamily: 'Inter, Arial, sans-serif',
          fontWeight: 'normal'
        },
        symbolHeight: 12,
        symbolWidth: 12,
        symbolRadius: 0,
        itemMarginTop: 0,
        itemMarginBottom: 0,
        padding: 12,
        margin: 0
      },
      plotOptions: {
        column: {
          stacking: false,
          groupPadding: 0.13,
          pointPadding: 0.02,
          borderWidth: 0,
          dataLabels: {
            enabled: false
          }
        }
      },
      credits: false,
      series: opts.series,
      colors: opts.colors
    };

    this.wireAccordionChart(opts.highchart_html_id, function () {
      return this.renderChart(opts.highchart_html_id, opts, jsOpts);
    }.bind(this));
  }
});

